<template>
    <div class="audiovisualLibrary">
        <div class="container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item  :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item >影音库</el-breadcrumb-item>
            </el-breadcrumb>
            <!-- 标题 -->
            <h3 class="font-style-s">
                <img src="@/assets/imgs/yy/3@2x.png" alt="">
                影音库
                <img src="@/assets/imgs/yy/4@2x.png" alt="">
            </h3>
            <!-- 内容 -->
            <ul>
                <li v-for="item in lists" :key="item.id" @click="handleDetail(item)">
                    <!-- <img :src="item.cover" alt=""> -->
                    <el-image class="img" fit="cover" :src="item.cover"></el-image>
                    <p>{{item.title}}</p>
                </li>
            </ul>
            <el-pagination
                background
                class="pagination"
                layout="prev, pager, next"
                @current-change="handlePageChange"
                :current-page="page"
                :total="total">
            </el-pagination>
        </div>
        <!-- 弹窗 -->
        <el-dialog
            custom-class="detail-dialog"
            :visible.sync="dialog"
            :show-close="false"
            width="700px"
        >
            <div style="font-size: 0;display: flex;justify-content: center; align-items: center;">
                <template v-if="detailUrl && /\.png$|\.jpg$|\.jpeg$/.test(detailUrl)">
                    <img style="width: 700px; height: 700px; object-fit: contain;" :src="detailUrl" alt="">
                </template>
                <template v-else-if="dialog">
                    <video class="video"
                           width="700px"
                           height="100%"
                           style="max-height: 700px;"
                           controls>
                        <source :src="detailUrl" type="video/mp4"> 
                        <source src="shanghai.ogg" type="video/ogg">
                        您的浏览器不支持视频标签。
                    </video>
                </template>
            </div>
        </el-dialog>

    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { getResourceLists } from '@/api/index.js';
import moment from 'moment';
import { useRoute, useRouter } from 'vue-router/composables';
import Dialog from '@/components/dialog.vue';
const router = useRouter();
const dialog = ref(false);

const lists = ref([]);
const page = ref(1);
const total = ref(0);
const detailUrl = ref('');

// 获取资讯列表
const getZxLists = () => {
    getResourceLists({
        pageNo: page.value,
        pageSize: 10
    }).then(({ data }) => {
        const _data = data?.list || [];
        lists.value = _data;
        total.value = data?.total || 0;
    });

};

const handleDetail = (item) => {
    dialog.value = true;
    detailUrl.value = item.url;
};


const handlePageChange = (val) => {
    page.value = val;
    getZxLists();
};

onMounted(() => {
    getZxLists();
});

</script>

<style lang="scss" scoped>
.container{
    padding: 30px 0;

   h3{
        font-weight:700;
        color:#555555;
        font-size:33px;
        text-align:center;
        margin-bottom: 22px;
        margin-top: 18px;
        img{
            width: 24px;
            height: 37px;
            vertical-align: middle;
        }
    }
    ul{
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        // justify-content: space-between;
        // flex-wrap: wrap;
        gap: 30px;
        li{
            text-align: center;
            background: #fff;
            box-sizing: border-box;
            cursor: pointer;
            .img{
               width:100%;
               height:226px;
            }
            p{
                color:#3b3939;
                font-size:17px;
                padding: 28px 35px;
            }
        }
    }
    .pagination{
        margin: 100px auto;
        text-align: center;
    }
}
::v-deep .el-dialog__body{
    padding: 0 !important;
}
</style>
<style>
.detail-dialog .el-dialog__header {
    display: none;
}
</style>